module.exports = __webpack_public_path__ + "static/media/sport.e95f41a5.jpg";